export default __webpack_public_path__ + "static/media/logouticon.5405f70f.svg";